import React from 'react';
import cn from 'classnames';

import {useContentCardContext} from '../../ContentCard';

import {IContentCardDescriptionProps} from './IContentCardDescription';

import styles from './ContentCardDescription.module.scss';

const ContentCardDescription = (props: IContentCardDescriptionProps) => {
	const {style} = useContentCardContext();

	return (
		<div
			className={cn(
				styles['content-card__description'],
				{[styles[`content-card__description--${style}`]]: style}
			)}
		>
			{props.children}
		</div>
	);
};

export default ContentCardDescription;
